import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICardAccountLinkDataTableRowFormMeta {
    bankAccount: FormInputMeta;
    bankAccountType: FormInputMeta;
    chequeBook: FormInputMeta;

    schema: any;
}

const cardAccountLinkDataTableRowFormMeta = {} as ICardAccountLinkDataTableRowFormMeta;

cardAccountLinkDataTableRowFormMeta.bankAccount = {
    name: "bankAccount",
    type: "text",
    label: "Compte Bancaire",
    placeholder: "Compte Bancaire",
    validation: yup.string().required("Champ Obligatoire !"),
};

cardAccountLinkDataTableRowFormMeta.bankAccountType = {
    name: "bankAccountType",
    type: "select",
    label: "Type Compte Bancaire",
    placeholder: "Type Compte Bancaire",
    validation: yup.string().required("Champ Obligatoire !"),
};

cardAccountLinkDataTableRowFormMeta.chequeBook = {
    name: "chequeBook",
    type: "checkbox",
    label: "Livre Chèque",
    placeholder: "Livre Chèque",
    validation: yup.boolean(),
};

cardAccountLinkDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(cardAccountLinkDataTableRowFormMeta));

export default cardAccountLinkDataTableRowFormMeta;